export const CUE_COMPLIANCE_UPSELL_CTA = {
  ctaId: 'workflows_compliance_upsell_cta',
  // The Discover button's impression. Fired by the card itself, not by the
  // CueCtaButton the modal moved into — that button fires its view on mount,
  // so leaving it on the card would count modal opens where this counts
  // button impressions. Only fired where the button renders, so the
  // view-to-click rate carries no impression a click was impossible from.
  viewEvent: 'workflows:cue_compliance_upsell_button_view',
  // Opens the modal. The dispatch to Cue now happens in the modal, under
  // CUE_COMPLIANCE_UPSELL_MODAL.
  clickEvent: 'workflows:cue_compliance_upsell_button_click',
  // Fired on the card's own Close button, not routed through CueCtaButton
  // (which only knows view/click). Without it, an ignored card and a
  // dismissed one are both just an absence of a click.
  closeEvent: 'workflows:cue_compliance_upsell_button_close',
} as const;

export const CUE_COMPLIANCE_UPSELL_MODAL = {
  ctaId: 'workflows_compliance_upsell_modal',
  // CueCtaButton fires this on mount, so it counts modal opens.
  viewEvent: 'workflows:cue_compliance_upsell_modal_view',
  // The "Start free trial" CTA, fired by the moved CueCtaButton. Same event
  // name shape as the card's own click so the two read as one funnel in
  // PostHog, distinguished by cta_id.
  clickEvent: 'workflows:cue_compliance_upsell_modal_click',
  // The "Discover Compliance" marketing link, and the × / backdrop dismissal.
  // Both carry an `action` property, since neither dispatches to Cue and the
  // event name alone would read marketing interest as a dismissal.
  closeEvent: 'workflows:cue_compliance_upsell_modal_close',
} as const;

// The `action` property on CUE_COMPLIANCE_UPSELL_MODAL.closeEvent.
export const MODAL_CLOSE_ACTION = {
  marketingLink: 'marketing_link',
  dismiss: 'dismiss',
} as const;
